import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withTranslation } from 'react-i18next';

import { actions } from 'state/auth';
import InvitationsForm from 'components/auth/InvitationsForm/styled';
import { i18n } from 'i18n';

const legalLinksByCountry = {
  es: {
    terms: '//ontruck.com/es/empresas/terminos-condiciones-cargadores/',
    privacy: '//ontruck.com/es/politica-de-privacidad/',
  },
  fr: {
    terms: '//ontruck.com/fr/termes-et-conditions/',
    privacy: '//ontruck.com/fr/confidentialite/',
  },
  en: {
    terms: '//ontruck.com/en/terms-and-conditions/',
    privacy: '//ontruck.com/en/privacy-policy/',
  },
  nl: {
    terms: '//ontruck.com/en/terms-and-conditions/',
    privacy: '//ontruck.com/en/privacy-policy/',
  },
};

const enhance = compose(
  withTranslation('Login'),
  connect(() => ({}), {
    login: actions.login,
  }),
  withProps(() => ({
    legalLinks: legalLinksByCountry[i18n.language || 'es'],
  }))
);

export default enhance(InvitationsForm);
